/*
 * Copyright (C) 2019 - Potentially Ltd
 *
 * Please see distribution for license.
 */

export interface CohortPlaylist {
  id: string;
  title: string;
}

export interface CohortDetails {
  startDate: string;
  endDate: string;
  isActive: boolean;
  playlistId?: string;
  playlistTitle?: string;
  playlistType?: string;
  capacity?: number;
  clientId?: string;
  clientName?: string;
  lmsSectionId?: string;
  cohortType?: string;
}

export interface UserGroups {
  title: string;

  _id: string;

  organizationId: string;

  memberCount: number;

  type: string;

  lastUpdatedOn: Date;

  createdAt?: Date;

  metadata?: unknown;

  cohortDetails?: CohortDetails;

  // front-end specific
  isEditing?: boolean;
}

export interface MemberGroups {
  id: string;
  name: string;
  type?: string;
}

export const NotDisplayableGroupTypes = ['STAFF', 'STUDENTS', 'STANDARD'];

export interface UserGroupMember {
  firstName: string;
  lastName: string;
  email: string;
  uid: string;
  image?: string;
}

export interface CreateUserGroups {
  title: string;
  type?: string;
  cohortConfig?: Partial<CohortDetails>;
}

export interface UserGroupUploadResult {
  processedUsers: string[];
  invitedUsers: string[];
  failedUsers: string[];
  successCount: number;
  failureCount: number;
}
